import { AllergenName } from '../apiTypes';
import Image from './Image';

const allergenMap: Record<AllergenName | 'spicy' | 'vegetarian', string> = {
  celery:
    'https://firebasestorage.googleapis.com/v0/b/firemenu-admin.appspot.com/o/allergens%2Fcelery.svg?alt=media&token=bbb6d67e-442f-4bfa-8e0a-21432d3ca803&_gl=1*bki92g*_ga*MTU0ODIzNTU4Ny4xNjM5ODIyNDA5*_ga_CW55HF8NVT*MTY4NzAwMDU5My43Mi4xLjE2ODcwMDA2MzMuMC4wLjA.',
  crustacean:
    'https://firebasestorage.googleapis.com/v0/b/firemenu-admin.appspot.com/o/allergens%2Fcrustacean.svg?alt=media&token=22c78ca7-98d2-45d1-84a8-221d71a4006f',
  eggs: 'https://firebasestorage.googleapis.com/v0/b/firemenu-admin.appspot.com/o/allergens%2Feggs.svg?alt=media&token=327d2257-f4b4-4dec-a876-9f5d116f804a',
  fish: 'https://firebasestorage.googleapis.com/v0/b/firemenu-admin.appspot.com/o/allergens%2Ffish.svg?alt=media&token=fb7f098f-e01f-4228-82a9-dc5e8ee493c5',
  gluten:
    'https://firebasestorage.googleapis.com/v0/b/firemenu-admin.appspot.com/o/allergens%2Fgluten.svg?alt=media&token=ed3ccdb9-46f8-48ee-91f2-2b62272fdfc7',
  lupins:
    'https://firebasestorage.googleapis.com/v0/b/firemenu-admin.appspot.com/o/allergens%2Flupins.svg?alt=media&token=239ab893-76cf-4335-be8d-a3289ca635c3',
  milk: 'https://firebasestorage.googleapis.com/v0/b/firemenu-admin.appspot.com/o/allergens%2Fmilk.svg?alt=media&token=08a0fa76-4f6d-42ee-a5e2-5bfb4d6cf611',
  mustard:
    'https://firebasestorage.googleapis.com/v0/b/firemenu-admin.appspot.com/o/allergens%2Fmustard.svg?alt=media&token=2c324487-51d5-4d13-997b-45bdd0c8380e',
  nuts: 'https://firebasestorage.googleapis.com/v0/b/firemenu-admin.appspot.com/o/allergens%2Fnuts.svg?alt=media&token=74637a72-d4fd-404f-afcb-93ef0d4e3510',
  peanuts:
    'https://firebasestorage.googleapis.com/v0/b/firemenu-admin.appspot.com/o/allergens%2Fpeanuts.svg?alt=media&token=21db884a-424a-4300-bcb3-416fbe12d64c',
  sesame:
    'https://firebasestorage.googleapis.com/v0/b/firemenu-admin.appspot.com/o/allergens%2Fsesame.svg?alt=media&token=0fec458e-e0ad-44ad-a037-21c6fee1151a',
  shellfish:
    'https://firebasestorage.googleapis.com/v0/b/firemenu-admin.appspot.com/o/allergens%2Fshellfish.svg?alt=media&token=75d4cf42-f26d-4332-83ed-85166c502276',
  soya: 'https://firebasestorage.googleapis.com/v0/b/firemenu-admin.appspot.com/o/allergens%2Fsoya.svg?alt=media&token=bb56ace8-43bb-4a4a-83fb-d8071a0541fd',
  sulphite:
    'https://firebasestorage.googleapis.com/v0/b/firemenu-admin.appspot.com/o/allergens%2Fsulphite.svg?alt=media&token=f9e45e40-daff-4445-af82-00db437d9a7b',
  spicy:
    'https://firebasestorage.googleapis.com/v0/b/firemenu-admin.appspot.com/o/allergens%2Fspicy.png?alt=media&token=934d223f-f257-4a2e-9e2e-53c74a1ff0b7',
  vegetarian:
    'https://firebasestorage.googleapis.com/v0/b/firemenu-admin.appspot.com/o/allergens%2Fvegetarian.png?alt=media&token=2ad42d6a-bdb3-49bd-8f08-31688508c05e',
};

type Props = {
  name: AllergenName | 'spicy' | 'vegetarian';
  width?: number;
};

const AllergenIcon = ({ name, width = 28 }: Props) => <Image src={allergenMap[name]} width={width} />;

export default AllergenIcon;
